import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  descripcion: Yup.string().min(2).max(50).required(),
  cuentaContableSoles: Yup.string().min(5).max(15).required(),
  cuentaContableDolares: Yup.string().min(5).max(15).required()
})
